import { render } from "./AuthorDetailPage.vue?vue&type=template&id=b4f0452c&scoped=true&ts=true"
import script from "./AuthorDetailPage.vue?vue&type=script&lang=ts"
export * from "./AuthorDetailPage.vue?vue&type=script&lang=ts"

import "./AuthorDetailPage.vue?vue&type=style&index=0&id=b4f0452c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f0452c"]])

export default __exports__